import confirm from '../../../utils/confirm.jsx';
import { money } from '../../../utils/format';

export function request(id, { amount, paymentMethod, cachetoken, securitycode }) {
    return confirm('Are you sure that you want to top up ' + money(amount) + '?', {
        type: 'CUSTOMERS_TOP_UP_REQUEST',
        securitycode,
        cachetoken,
        paymentMethod,
        amount,
        id
    });
}

export function error(id, errors) {
    return {
        type: 'CUSTOMERS_TOP_UP_ERROR',
        errors,
        id
    };
}

export function form(id, data) {
    return {
        type: 'CUSTOMERS_TOP_UP_FORM',
        data,
        id
    };
}

export function finish(id, { customer, transaction }) {
    return {
        type: 'CUSTOMERS_TOP_UP_FINISH',
        transaction,
        customer,
        id
    };
}

export function clear(id) {
    return {
        type: 'CUSTOMERS_TOP_UP_CLEAR',
        id
    };
}
